module.exports = __webpack_public_path__ + "assets/img/5congzhi_m.099bd4ab.png";